import { isUnchanged } from './isUnchanged'

export const resolveReference = <T>(current: T | undefined, next: T): T =>
  current !== undefined && isUnchanged(current, next) ? current : next
